// SortSelection.tsx
import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface SortSelectionProps {
  currentSort: string;
  onSortChange: (sortValue: string) => void;
  isLoading?: boolean;
}

const SORT_OPTIONS = [
  { value: 'Alphabetical A-Z', label: 'Alphabetical A-Z' },
  { value: 'Alphabetical, Z-A', label: 'Alphabetical Z-A' },
  { value: 'Price, low to high', label: 'Price, low to high' },
  { value: 'Price, high to low', label: 'Price, high to low' }
];

const SortSelection: React.FC<SortSelectionProps> = ({
                                                       currentSort,
                                                       onSortChange,
                                                       isLoading = false
                                                     }) => {
  const handleSortChange = (event: SelectChangeEvent<string>) => {
    onSortChange(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 'auto' }}>
      <Select
        value={currentSort || 'Alphabetical A-Z'}
        onChange={handleSortChange}
        disabled={isLoading}
        displayEmpty
        renderValue={() => 'Sort'}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            py: 1,
            pr: '32px !important',
            pl: 1,
          }
        }}
      >
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              {currentSort === option.value && (
                <CheckIcon fontSize="small" color="primary" />
              )}
            </ListItemIcon>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SortSelection;